/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Avatar, Box, Grid, Tab } from '@mui/material';
import { AudioTranscriber, DialogForm, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextEditor, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { AccessRoleDTO, AccessRoleFilterDTO, InterviewDTO, InterviewFilterDTO, PeopleDTO, ResumeDTO, ResumeVacancyDTO, UserDTO, UserFilterDTO, ValueListDTO } from '../../../shared/interfaces';
import { formatDateTime } from '../../../shared/utils';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useTranslation } from 'react-i18next';

interface IInterviewMaintenanceProps {
    vacancyId?: string;
    resumeId?: string;
    data: any;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const InterviewMaintenance: React.FC<IInterviewMaintenanceProps> = ({ vacancyId, resumeId, data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [userList, setUserList] = useState<UserDTO[]>([]);
    const [interviewDTO, setInterviewDTO] = useState<InterviewDTO>();

    const [InterviewerList, setInterviewerList] = useState<PeopleDTO[]>([]);
    const [typeList, setTypeList] = useState<ValueListDTO[]>([]);
    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [reasonList, setReasonList] = useState<ValueListDTO[]>([]);
    const [resumeList, setResumeList] = useState<ResumeDTO[]>([]);

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const [selectedTab, setSelectdTab] = useState('1');
    const [isListening, setIsListening] = useState<boolean>(false);

    const [accessRolePermissionDTO, setAccessRolePermissionDTO] = useState<AccessRoleDTO>();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const { t } = useTranslation();

    useEffect(() => {
        setInterviewDTO({
            ...interviewDTO,
            id: '',
            resumeId: '',
            vacancyId: vacancyId,
            typeId: '',
            statusId: '',
            interviewedById: '',
            feedback: '',
            evaluation: '',
            transcription: '',
            transcriptionAI: ''
        } as InterviewDTO);
    }, [data, vacancyId]);

    useEffect(() => {
        if (isOpenMaintenance && interviewDTO?.id != '') {
            handleUserGetAllAsync();
            handleGetInterviewByIdAsync();
            handleInterviewerGetAllAsync();
            handleResumeGetAllViewAsync();
            handleListGetAll(ListId.talentsphere.interview.typeId, setTypeList);
            handleListGetAll(ListId.talentsphere.interview.statusId, setStatusList);
            handleListGetAll(ListId.talentsphere.interview.reasonId, setReasonList);

            handleGetPermission(ListId.talentsphere.interviewId, setAccessRolePermissionDTO);
        }
    }, [data, isOpenMaintenance]);

    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'valueindex, value ASC'
        };
        GenericService.GetAllAsync1(
            'parmsphere.valueList',
            valueListFilterDTO,
            setLoading,
            setList,
            showMessage
        );
    }, []);

    const handleGetPermission = useCallback(async (featureId: string, setList: any) => {
        const accessRoleFilterDTO: AccessRoleFilterDTO = {
            featureId: featureId,
            userId: userInfo.user.id,
        };
        GenericService.PostGenericAsync1('authsphere.AccessRole', 'GetPermissionAsync', accessRoleFilterDTO, setActionExecuted, setLoading, undefined, setList,);
    }, []);

    const handleUserGetAllAsync = useCallback(async () => {
        const userFilterDTO: UserFilterDTO = {
            companyId: '',
            peopleId: '',
            userName: '',
            isServiceAccount: false
        };
        GenericService.GetAllViewAsync1('authsphere.user', userFilterDTO, setActionExecuted, setLoading, setUserList, showMessage, false);
    }, []);

    const handleInterviewerGetAllAsync = useCallback(async () => {
        const peopleFilterDTO = {

        };
        GenericService.GetAllAsync1('corpsphere.people', peopleFilterDTO, setLoading, setInterviewerList, showMessage);
    }, []);

    const handleGetInterviewByIdAsync = useCallback(async () => {
        if (data && data.id) {
            await GenericService.GetByIdAsync1('talentsphere.interview', data.id, setLoading, setInterviewDTO, showMessage);
        }
    }, [data, vacancyId]);

    const handleResumeGetAllViewAsync = useCallback(async () => {
        const filterDTO = {
            resumeId: '',
            vacancyId: vacancyId,
            statusId: '',
            createdById: '',
            searchAssociated: true
        };

        GenericService.GetAllViewAsync1('talentsphere.ResumeVacancy', filterDTO, setActionExecuted, setLoading, setResumeList, showMessage, true);
    }, []);

    const handleSaveClick = useCallback(async () => {
        const dto = interviewDTO as InterviewDTO;

        if (interviewDTO?.id === '' || interviewDTO?.id === undefined) {
            dto.createdById = userInfo.user.id;
            dto.vacancyId = vacancyId ?? '';
            GenericService.AddAsync1('talentsphere.interview', dto, setInterviewDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            if (!accessRolePermissionDTO?.allowUpdate) {
                showMessage(t('message.allowUpdate'), 'info');
                return;
            }

            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('talentsphere.interview', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [interviewDTO]);

    const handleTranscriberFeedback = useCallback(async () => {
        setIsListening(!isListening);
    }, [isListening]);

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);

        if (type != 'success')
            setIsOpenMaintenance(true);
    }
    const actions: IDialogActions[] = [
        // { id: 'transcribeFeddback', text: isListening ? 'Stop Feedback Transcription' : 'Start Feedback Transcription', icon: 'mic_none_outlined', iconColor: isListening ? 'warning' : 'success', setAction: handleTranscriberFeedback, isClose: false },
        { id: 'save', text: t('interview.maintenance.actions.save'), icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick, isClose: isOpenMaintenance },
        { id: 'close', text: t('interview.maintenance.actions.close'), icon: 'close_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setSelectdTab(newValue);
    };

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title={t('interview.maintenance.dialogForm.title')}
                icon='people_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='typeId'
                                label={t('interview.maintenance.selectField.type')}
                                setValue={setInterviewDTO}
                                value={interviewDTO?.typeId}
                                obj={interviewDTO}
                                valueList={typeList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='interviewedById'
                                label={t('interview.maintenance.selectField.interviwer')}
                                setValue={setInterviewDTO}
                                value={interviewDTO?.interviewedById}
                                obj={interviewDTO}
                                valueList={InterviewerList}
                                hasNoneSelect={true}
                                labelKey='fullName'
                                valueKey='id'
                                searchable={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <SelectField
                                id='resumeId'
                                label={t('interview.maintenance.selectField.resume')}
                                setValue={setInterviewDTO}
                                value={interviewDTO?.resumeId}
                                obj={interviewDTO}
                                valueList={resumeList}
                                hasNoneSelect={true}
                                labelKey='name'
                                valueKey='resumeId'
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <SelectField
                                id='statusId'
                                label={t('interview.maintenance.selectField.status')}
                                setValue={setInterviewDTO}
                                value={interviewDTO?.statusId}
                                obj={interviewDTO}
                                valueList={statusList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        {interviewDTO?.statusId === ListId.talentsphere.interview.statusRepprovedId ?
                            <Grid item xs={12} md={6}>
                                <SelectField
                                    id='reasonId'
                                    label={'Reason'}
                                    setValue={setInterviewDTO}
                                    value={interviewDTO?.reasonId}
                                    obj={interviewDTO}
                                    valueList={reasonList}
                                    hasNoneSelect={true}
                                    labelKey='value'
                                    valueKey='id'
                                    searchable={true}
                                />
                            </Grid> :
                            <></>}
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12}>
                                <TabContext value={selectedTab} >
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <TabList onChange={handleChange} aria-label={t('interview.maintenance.tabList.aria-label')}>
                                            <Tab label={t('interview.maintenance.tabList.feedback')} value="1" />
                                            <Tab label={t('interview.maintenance.tabList.evaluationAI')} value="2" />
                                            <Tab label={t('interview.maintenance.tabList.transcript')} value="3" />
                                            <Tab label={t('interview.maintenance.tabList.transcriptAI')} value="4" />
                                        </TabList>
                                    </Box>
                                    <TabPanel value="1" sx={{ ml: -2, mr: -3, mb: -3 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={12}>
                                                <TextFieldInput
                                                    id='feedback'
                                                    label={''}
                                                    placeholder={t('interview.maintenance.textFieldInput.feedback')}
                                                    value={interviewDTO?.feedback}
                                                    setValue={setInterviewDTO}
                                                    obj={interviewDTO}
                                                    required={true}
                                                    multiline={true}
                                                    rows={18}
                                                    readonly={interviewDTO?.id ? userInfo.user.id == interviewDTO?.createdById ? false : true : false}
                                                />
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value="2" sx={{ ml: -2, mr: -3, mb: -3 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={12}>
                                                <TextFieldInput
                                                    id='evaluation'
                                                    label={''}
                                                    placeholder={t('interview.maintenance.textFieldInput.evaluation')}
                                                    value={interviewDTO?.evaluation}
                                                    setValue={setInterviewDTO}
                                                    obj={interviewDTO}
                                                    required={true}
                                                    multiline={true}
                                                    rows={18}
                                                    readonly={interviewDTO?.id ? userInfo.user.id == interviewDTO?.createdById ? false : true : false}
                                                />
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value="3" sx={{ ml: -2, mr: -3, mb: -3 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={12}>
                                                <TextFieldInput
                                                    id='transcription'
                                                    label={''}
                                                    placeholder={t('interview.maintenance.textFieldInput.transcription')}
                                                    value={interviewDTO?.transcription}
                                                    setValue={setInterviewDTO}
                                                    obj={interviewDTO}
                                                    required={true}
                                                    multiline={true}
                                                    rows={18}
                                                    readonly={interviewDTO?.id ? userInfo.user.id == interviewDTO?.createdById ? false : true : false}
                                                />
                                            </Grid>
                                            {/* {isListening && (
                                                <Grid item xs={12} md={12}>
                                                    <AudioTranscriber
                                                        id='transcription'
                                                        value={interviewDTO?.transcription}
                                                        setValue={setInterviewDTO}
                                                        obj={interviewDTO}
                                                        isListening={isListening}
                                                        setIsListening={setIsListening}
                                                    />
                                                </Grid>
                                            )} */}
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value="4" sx={{ ml: -2, mr: -3, mb: -3 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={12}>
                                                <TextFieldInput
                                                    id='transcriptionAi'
                                                    label={''}
                                                    placeholder={t('interview.maintenance.textFieldInput.transcriptionAI')}
                                                    value={interviewDTO?.transcriptionAI}
                                                    setValue={setInterviewDTO}
                                                    obj={interviewDTO}
                                                    required={true}
                                                    multiline={true}
                                                    rows={18}
                                                    readonly={interviewDTO?.id ? userInfo.user.id == interviewDTO?.createdById ? false : true : false}
                                                />
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                </TabContext>
                            </Grid>
                        </Grid>
                        {interviewDTO?.id ? (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <TextFieldReadOnly
                                        id={'id'}
                                        label={t('interview.maintenance.textFieldReadOnly.ID')}
                                        value={interviewDTO.id}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'createdById'}
                                        label={t('interview.maintenance.textFieldReadOnly.createdById')}
                                        value={userList.find(x => x.id === interviewDTO.createdById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'creationDateTime'}
                                        label={t('interview.maintenance.textFieldReadOnly.creationDate')}
                                        value={formatDateTime(String(interviewDTO.creationDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updatedById'}
                                        label={t('interview.maintenance.textFieldReadOnly.UpdatedBy')}
                                        value={userList.find(x => x.id === interviewDTO.updatedById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updateDateTime'}
                                        label={t('interview.maintenance.textFieldReadOnly.updateDateTime')}
                                        value={formatDateTime(String(interviewDTO.updateDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                    </Grid>
                </React.Fragment>
            </DialogForm >
        </React.Fragment >
    );
};